import type { PaymentCredit } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { PaymentCreditInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "paymentToken", "hasPayjpValidation", "hotelEmail"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type PaymentCreditFormModel = AutoGeneratorForFormModel<
	PaymentCreditInputZodSchemaType,
	ExcludeKeys,
	PaymentCredit & {
		hotelEmail: string;
		receipt: {
			id: string;
			addressee: string;
		};
	}
>;
